import React, { forwardRef } from "react";
import styled from "styled-components";

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Label = styled.span`
  color: rgb(33, 37, 67);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: solid 1px
    ${(props) => (props.error ? "rgb(220, 38, 38)" : "rgb(224, 228, 244)")};
  border-radius: 8px;
  background: rgb(255, 255, 255);
  padding: 0 16px;
  height: 42px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: rgb(97, 98, 197);
  }
`;

const StyledInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  font-family: ${(props) =>
    props.$isPassword ? "'Courier New', Courier, monospace" : "Montserrat, sans-serif"};
  font-weight: 500;
  line-height: 160%;
  color: rgb(33, 37, 67);
  background: transparent;

  &::placeholder {
    color: rgb(179, 182, 195);
  }
  ${(props) =>
    props.type === "number" &&
    `
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    -moz-appearance: textfield;
  `}
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: start;
`;

const Required = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-weight: 700;
  margin-left: 4px;
`;

const Input = forwardRef(
  (
    {
      label,
      type = "text",
      placeholder,
      value,
      onChange,
      icon,
      onIconClick,
      error,
      errorMessage,
      name,
      required = false,
      autoComplete = "off",
      button,
      ...props
    },
    ref // <- this is the forwarded ref
  ) => {
    const isPasswordField = (label === "Password" || label === "New password" || label === "Confirm password" || label === "Old password") ? true : false
    return (
      <InputContainer>
        {label && (
          <Label>
            {label} {required && <Required>*</Required>}
          </Label>
        )}
        <InputWrapper error={error}>
          <StyledInput
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            autoComplete={autoComplete}
            name={name}
            ref={ref} // <- pass it here
            $isPassword={isPasswordField}
            {...props}
          />
          {icon && <Icon src={icon} onClick={onIconClick} alt="input icon" />}
          {button && button}
        </InputWrapper>
        {error && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </InputContainer>
    );
  }
);

export default Input;
